import React from 'react';
import { Link } from 'react-scroll';

const fixedLink = props => {
  return (
    <Link
      className={props.classes}
      style={{ cursor: 'pointer' }}
      activeClass='active'
      to={props.target}
      spy={true}
      smooth={true}
      offset={props.offset || -45}
      duration={200}
    >
      {props.children}
    </Link>
  );
};

export default fixedLink;
